module.exports = __webpack_public_path__ + "static/media/uvu-logo.9d2efc91.svg";